"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = exports.Put = exports.setOrDeleteLabel = exports.Get = exports.getLabelValuesAsListItem = exports.getLabels = exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID = exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID = void 0;
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var LabelType_1 = require("../shared/LabelType");
var canSubmitLabel_1 = require("./canSubmitLabel");
var ERROR_NOTIFYING_SERVER_RESPONSE_DELAY = 2000;
exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID = 'data-quality-dialog-type';
exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID = 'sensitivity-label-dialog-type';
var partialConfig = {
    restApiVersion: '3.16',
    serverWideRequest: false,
    endpoint: 'labels',
};
function getLabels(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var resolveOwners, transform, response, data, labels;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resolveOwners = params.resolveOwners, transform = params.transform;
                    if (resolveOwners) {
                        throw new Error('Resolve owners is not implemented, getLabels should only be used for the actions menu');
                    }
                    return [4 /*yield*/, exports.Get.getLabelsSparse(params)];
                case 1:
                    response = _b.sent();
                    data = (_a = response.labelList.label) !== null && _a !== void 0 ? _a : [];
                    labels = (0, vizportalclient_common_components_1.groupByToMultimap)({
                        data: data,
                        keyTransform: function (original) { return ({ contentId: original.contentId, contentType: original.contentType.toLowerCase() }); },
                        valTransform: transform,
                        keyBy: function (_a) {
                            var contentId = _a.contentId, contentType = _a.contentType;
                            return "".concat(contentType, "-").concat(contentId);
                        },
                    });
                    return [2 /*return*/, labels];
            }
        });
    });
}
exports.getLabels = getLabels;
var getConfig = __assign(__assign({}, partialConfig), { httpMethod: 'POST' });
/**
 * getLabelsSparse is intended to be used for the set warning|certification action and
 * doesn't resolve user information because that is not required for the action
 *
 * @param params The list of assets to be queried for and the optional category to filtery by
 * @returns A collection of unresolved labels, i.e.: there is no owner or asset information
 */
function getLabelsSparse(params) {
    var request = contentItemsToContentList(params);
    var queryParams = makeLabelsQueryParams(params);
    var makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    var result = makeJsonRestApiRequest(getConfig, request, queryParams);
    return result;
}
function getLabelValuesSparse(params) {
    var labelValueConfig = getLabelValueConfig(params.category);
    var makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    var result = makeJsonRestApiRequest(labelValueConfig);
    return result;
}
function getLabelValuesAsListItem(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseList;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getLabelValuesSparse(params)];
                case 1:
                    response = _b.sent();
                    responseList = (_a = response.labelValueList.labelValue) !== null && _a !== void 0 ? _a : [];
                    return [2 /*return*/, responseList.map(convertDataToListItem)];
            }
        });
    });
}
exports.getLabelValuesAsListItem = getLabelValuesAsListItem;
function convertDataToListItem(type) {
    switch (type.name) {
        case 'SENSITIVE_DATA':
            return labelTypeListItem(LabelType_1.LabelType.SENSITIVE_DATA);
        case 'DEPRECATED':
            return labelTypeListItem(LabelType_1.LabelType.DEPRECATED);
        case 'STALE':
            return labelTypeListItem(LabelType_1.LabelType.STALE);
        case 'WARNING':
            return labelTypeListItem(LabelType_1.LabelType.WARNING);
        case 'MAINTENANCE':
            return labelTypeListItem(LabelType_1.LabelType.MAINTENANCE);
        default:
            return {
                content: type.name,
                value: type.name,
                testId: exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID + '-' + type.name
            };
    }
}
function labelTypeListItem(type) {
    var testIdPrefix = type === LabelType_1.LabelType.SENSITIVE_DATA ? exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID : exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
    return {
        content: (0, LabelType_1.localizeLabelTypeName)(type),
        value: (0, LabelType_1.labelTypeToString)(type),
        testId: testIdPrefix + '-' + (0, LabelType_1.labelTypeToString)(type).toLowerCase()
    };
}
function getLabelValueConfig(_a) {
    var category = _a.category;
    return {
        restApiVersion: 'exp',
        serverWideRequest: false,
        endpoint: "labelValues/?categories=".concat(category),
        httpMethod: 'GET',
    };
}
exports.Get = {
    getConfig: getConfig,
    getLabelsSparse: getLabelsSparse,
};
function setOrDeleteLabel(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var luid, labelContent, makeJsonRestApiRequest, command;
        return __generator(this, function (_c) {
            luid = params.luid, labelContent = params.labelContent, makeJsonRestApiRequest = params.makeJsonRestApiRequest;
            command = (0, canSubmitLabel_1.canSubmitLabel)({ active: (_a = labelContent === null || labelContent === void 0 ? void 0 : labelContent.active) !== null && _a !== void 0 ? _a : false, message: (_b = labelContent === null || labelContent === void 0 ? void 0 : labelContent.message) !== null && _b !== void 0 ? _b : '' });
            switch (command) {
                case 'DELETE':
                    if (luid) {
                        return [2 /*return*/, exports.Delete.deleteLabel({ luid: luid, makeJsonRestApiRequest: makeJsonRestApiRequest })];
                    }
                    else {
                        return [2 /*return*/, exports.Delete.deleteLabels(params)];
                    }
                case 'SUBMIT':
                    return [2 /*return*/, exports.Put.setLabels(params)];
                case 'TOOLONG':
                    throw new Error('The label message was too long to submit to the server');
                case 'NOMESSAGE':
                    throw new Error('A message is required for a label to be submitted');
                default:
                    (0, vizportalclient_common_components_1.assertUnreachable)(command);
                    throw new Error('Unreachable');
            }
            return [2 /*return*/];
        });
    });
}
exports.setOrDeleteLabel = setOrDeleteLabel;
var putConfig = __assign(__assign({}, partialConfig), { httpMethod: 'PUT' });
function setLabels(params) {
    var _this = this;
    var queryParams = makeLabelsQueryParams(params);
    var request = __assign(__assign({}, contentItemsToContentList(params)), { label: __assign({}, params.labelContent) });
    var makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    var result = makeJsonRestApiRequest(putConfig, request, queryParams)
        .then(function (t) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, vizportalclient_common_components_1.delayPromise)(ERROR_NOTIFYING_SERVER_RESPONSE_DELAY)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, t];
            }
        });
    }); });
    return result;
}
exports.Put = {
    putConfig: putConfig,
    setLabels: setLabels,
};
function deleteLabels(params) {
    return __awaiter(this, void 0, void 0, function () {
        var config, queryParams, request, makeJsonRestApiRequest, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = __assign(__assign({}, partialConfig), { httpMethod: 'DELETE', endpoint: "labels" });
                    queryParams = makeLabelsQueryParams(params);
                    request = contentItemsToContentList(params);
                    makeJsonRestApiRequest = params.makeJsonRestApiRequest;
                    result = makeJsonRestApiRequest(config, request, queryParams);
                    return [4 /*yield*/, (0, vizportalclient_common_components_1.delayPromise)(ERROR_NOTIFYING_SERVER_RESPONSE_DELAY)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function deleteLabel(_a) {
    var luid = _a.luid, makeJsonRestApiRequest = _a.makeJsonRestApiRequest;
    return __awaiter(this, void 0, void 0, function () {
        var config, result;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    config = __assign(__assign({}, partialConfig), { httpMethod: 'DELETE', endpoint: "labels/".concat(luid) });
                    return [4 /*yield*/, makeJsonRestApiRequest(config, undefined).then(function (t) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, vizportalclient_common_components_1.delayPromise)(ERROR_NOTIFYING_SERVER_RESPONSE_DELAY)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, t];
                                }
                            });
                        }); })];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.Delete = {
    deleteLabels: deleteLabels,
    deleteLabel: deleteLabel
};
function contentItemsToContentList(params) {
    return {
        contentList: {
            content: params.contentItems.map(function (i) { return ({ id: i.contentId, contentType: i.contentType }); })
        }
    };
}
function makeLabelsQueryParams(params) {
    var category = params.category;
    if (!category) {
        return undefined;
    }
    return {
        categories: category
    };
}
//# sourceMappingURL=Labels.js.map